<template>
  <section>
    <HelpPage :axData="contentData"/>
  </section>
</template>

<script>
  import HelpPage from '@/components/common/HelpPage.vue';

export default {
  name: 'costs',
  components: {
    HelpPage
  },
  data() {
    return {
      contentData: {
        title: '收费标准',
        tableDate: {
          column: ['停车场', '车位数量', '月收费标准'],
          data: [['360大厦地库', '214个', '464元'], ['798停车场', '310个', '300元']],
        },
        promptData: [
          '车位费用会从每月的工资(税前)中直接扣除；',
          '如您需要退还车证，请邮件发送至(<a href="mailto:g-xz-badge@360.cn">g-xz-badge@360.cn</a>)；',
          '公司为代收停车费，车辆在停车场出现问题可与相关物业部门联系，798园区：<a href="tel:59789177">59789177</a>，电子城物业：<a href="tel:56920166">56920166</a>；',
          '关于油补的申请和报销的相关疑问，请咨询财务报销窗口。'
        ],
      },
    };
  },
};
</script>
